import { Link } from "react-router-dom";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CBadge,
} from "@coreui/react-pro";
import CIcon from "@coreui/icons-react";
import { cilStar } from "@coreui/icons";
import { useToast } from "../../context/useToast";
import { routePaths } from "../../routes/route-paths";

export function SignalManagementPreview() {
  const { showInfo } = useToast();

  return (
    <div>
      <CBadge color="warning" className="text-uppercase mb-2">
        <CIcon icon={cilStar} size="sm" className="me-1" />
        Preview · Not yet available
      </CBadge>
      <h1>Signal Management</h1>
      <p className="lead text-body-secondary">
        Signal Management is our next offering — bring your own broker
        connection and let Scryer route trading signals into curated portfolios
        on your behalf.
      </p>

      <CRow xs={{ gutter: 4 }} className="mb-4">
        <CCol md={4}>
          <CCard className="h-100">
            <CCardHeader>1. Portfolios</CCardHeader>
            <CCardBody className="text-body-secondary">
              Each portfolio is a TradersPost connection with its own sizing,
              risk limits, and signal-routing configuration. Start with one;
              expand as you grow.
            </CCardBody>
          </CCard>
        </CCol>
        <CCol md={4}>
          <CCard className="h-100">
            <CCardHeader>2. Baskets</CCardHeader>
            <CCardBody className="text-body-secondary">
              Subscribe a portfolio to a curated basket of strategies. Scryer
              chooses the mix; you focus on capital allocation. Switch baskets
              in one click.
            </CCardBody>
          </CCard>
        </CCol>
        <CCol md={4}>
          <CCard className="h-100">
            <CCardHeader>3. Audit &amp; control</CCardHeader>
            <CCardBody className="text-body-secondary">
              Full signal history, late-entry handling, exit-position controls,
              and granular pause/resume so you stay in charge of every trade.
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CCard className="border-warning" style={{ borderWidth: 2 }}>
        <CCardBody className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
          <div>
            <h3 className="h5 mb-1">Want a heads-up when it goes live?</h3>
            <p className="text-body-secondary mb-0">
              We'll email you the moment Signal Management opens for early
              access.
            </p>
          </div>
          <div className="d-flex gap-2">
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => showInfo("Thanks — we'll let you know.")}
            >
              Notify me
            </button>
            <Link to={routePaths.dashboard} className="btn btn-outline-secondary">
              Back to dashboard
            </Link>
          </div>
        </CCardBody>
      </CCard>
    </div>
  );
}
